module.exports = __webpack_public_path__ + "007f905e.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/whatsapp_icon.png
// module id = 2073
// module chunks = 15 17 32 36